import React from 'react'
import 'semantic-ui-css/components/grid.css'
import JSS from '@oldscope/jss'
import { arr_ensure } from '@oldscope/utils/array'
import { size, get, chunk, compact } from 'lodash'
import ContainerSizeProvider from '@oldscope/responsive/ContainerSizeProvider'

class ColumnsBase extends React.Component {
  render() {
    const { children, sizePicker, classes } = this.props

    const columns = compact(arr_ensure(children)).filter(
      item =>
        (get(item, 'type.componentName') || get(item, 'type.name')) === 'Column',
    )
    const numColumns = size(columns)

    const columnsPerRow = sizePicker({
      'w<420': 1,
      'w<600': 2,
      'w<800': 3,
      default: numColumns,
    })

    const rows = chunk(columns, columnsPerRow)

    return (
      <div className={classes.container}>
        {rows.map((items, i) => (
          <div className={classes.row} key={i}>
            {items}
          </div>
        ))}
      </div>
    )
  }
}

const Columns = JSS({
  container: {
    margin: '-16px 0px',
  },

  row: {
    display: 'flex',
    margin: '0 -16px',
  },
})(ContainerSizeProvider(['w<420'])(ColumnsBase))

class ColumnBase extends React.Component {
  static displayName = 'Column'

  render() {
    const { classes, children } = this.props
    return <div className={classes.column}>{children}</div>
  }
}

const Column = JSS({
  column: {
    position: 'relative',
    flex: '1 1 0px',
    padding: '16px 16px',
    '& img': {
      maxWidth: '100%',
    },
  },
})(ColumnBase)

export { Columns, Column }
